<template>
    <div>
        <div class="block with-errors" @click="$router.push({ name: 'subscription' })">
            <div class="title">
                <IconMoney height="20" classes="settings-icon vertical-center" />
                <div>{{ $t('subscription') }}</div>
                <div class="change" @click="$router.push({ name: 'subscription' })">
                    {{ $t('change') }}
                </div>
            </div>
            <div class="value">
                <div class="">
                    {{ $t('tariff') }} «{{ subscription.name[$i18n.locale] }}»
                    <sup v-if="expired" class="ml-1 text-xs text-prime-500">●</sup>
                </div>
                <div class="action">
                    <IconRightChevron height="16" classes="vertical-center ml-auto" />
                </div>
            </div>
            <div class="bottom">
                <div class="warning-text pr-16 lg:ml-30 lg:pl-px lg:text-left">
                    <div v-if="isEndless">{{ $t('neverExpire') }}</div>
                    <div v-if="canExpire && ! expired" class="text-prime-500">
                        {{ $t('expire', { date: localizeNext }) }}
                    </div>
                    <div v-if="expired" class="text-prime-500">
                        {{ $t('expired') }}
                    </div>
                    <div v-if="isPaid && ! canExpire">
                        {{ 
                            subscription.price 
                            + ' ' + $t('currency.' + subscription.currency) 
                            + '/' + $t('periods.' + subscription.period)
                        }} <br>
                        {{ $t('nextPayment', { date: localizeNext }) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IconRightChevron from '@/components/visual/icons/IconRightChevron'
import IconMoney from '@/components/visual/icons/IconMoney'
import { mapState } from 'vuex'

export default {
    components: { IconRightChevron, IconMoney },
    methods: {
    },
    mounted() {
        this.$store.dispatch('locale/loadSubscriptions')
    },
    computed: {
      localizeNext() {
        return this.subscription.next_transaction_date 
            ? this.$d(new Date(this.subscription.next_transaction_date), 'short') 
            : ''
      },
      canExpire() {
        return this.subscription.price == 0 && ! this.subscription.prolongable 
            && this.subscription.period != 'endless' || this.subscription.status == 'Cancelled'
      },
      expired() {
        return this.subscription.status == 'PastDue'
      },
      isPaid() {
        return this.subscription.price > 0
      },
      isEndless() {
        return this.subscription.period == 'endless'
      },
        ...mapState('auth', {
            subscription: state => state.user.subscription
        }),
    }
}
</script>

<i18n locale="ru" lang="yaml">
    subscription: "Моя подписка"
    tariff: "Тариф"
    change: "Изменить"
    currency:
        RUB: "рублей"
    expire: "Закончится {date}"
    expired: "Оплата за подписку просрочена"
    neverExpire: "Не закончится никогда"
    nextPayment: "Следующий автоматический платеж {date}"
</i18n>

<i18n locale="en" lang="yaml">
    subscription: "My subscription"
    change: "Change"
    tariff: "Plan"
    currency:
        RUB: "RUB"
    expire: "Will expire {date}"
    neverExpire: "Never expire"
    nextPayment: "Next payment {date}"
</i18n>
